/* istanbul ignore file */
/**
 * Created by gboue on 8/24/22
 * File: ActionsRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useContext } from 'react'
import { LABEL_OWNERS_ACTION_DELETE, LABEL_OWNERS_ACTION_VERIFY, LABEL_OWNERS_ACTION_VERIFY_INSTRUCTIONS } from '../../../../../constants/LabelConstants'
import AuthContext from '../../../../../../common/context/AuthContext'
import OwnerVerificationIcon from './OwnerVerificationIcon'
import type { RowInstance } from '@panwds/react-table'
import { IDP_OWNER_TYPES } from '../../../../../constants/IAMConstants'

/**
  *   Owners actions button table cell
  */

/**
  * type    status    same_user    icon
    dns     pending   yes          gear
    dns     pending   no           n/a
    dns     verified  yes          gear
    dns     verified  no           trash
    grant   verified  yes          gear
    grant   verified  no           trash
  */

const ActionsRenderer: VFC<{
  loading: boolean,
  fetchData: Function,
  value: { type: string, status: string, verificationString: string },
  onActionClick: Function,
  row: RowInstance<any>,
  domain: string,
  openDeleteModal: Function,
  closeDeleteModal: Function,
  isVerifyLoading: any
}> = ({ loading, fetchData, value, onActionClick, row, domain, openDeleteModal, closeDeleteModal, isVerifyLoading }) => {

  const { type, status, verificationString } = value
  const { values: { owner_name: owner } } = row
  const { user } = useContext(AuthContext)
  const isSameUser = owner === user?.email

  const items = []

  if (type !== IDP_OWNER_TYPES.OWNER_GRANT) {
    items.push(
      { value: LABEL_OWNERS_ACTION_VERIFY },
      { value: LABEL_OWNERS_ACTION_VERIFY_INSTRUCTIONS },
    )
  }

  if (isSameUser) {
    items.push(
      { value: LABEL_OWNERS_ACTION_DELETE },
    )
  }

  // TODO: No point in having a single child in this component. Delete OwnerVerificationIcon and move all logic to ActionsRenderer.
  return (
    <OwnerVerificationIcon
      loading={loading}
      fetchData={fetchData}
      domain={domain}
      ownerName={owner}
      verificationString={verificationString}
      status={status}
      type={type}
      isSameUser={isSameUser}
      onActionClick={onActionClick}
      items={items}
      isVerifyLoading={isVerifyLoading}
      openDeleteModal={openDeleteModal}
      closeDeleteModal={closeDeleteModal}/>
  )
}

ActionsRenderer.propTypes = {}
export default ActionsRenderer

